import { defineMessages } from 'react-intl';

export default defineMessages({
  depositInformation: 'Deposit Information',
  approximateBalance: 'Approximate balance',
  depositComposition: 'Deposit Composition',
  borrowingPowerAvailable: 'Borrowing power available',

  borrowInformation: 'Borrow Information',
  youBorrowed: 'You borrowed',
  yourCollateral: 'Your collateral',
  currentLTV: 'Current LTV',
  borrowingPowerUsed: 'Borrowing Power Used',
  borrowComposition: 'Borrow Composition',
  details: 'Details',

  noDeposits: 'No deposits yet',
  connectWallet: 'Please connect your wallet',
});
